import { fireEvent } from 'utils/generic/event-bus';
import { TAdvancedFreebet } from 'interfaces/bet-data';

export enum EProfitBoostActions {
  CHECK_PROFIT_BOOST = 'CHECK_PROFIT_BOOST',
  TOGGLE_PROFIT_BOOST = 'TOGGLE_PROFIT_BOOST'
}

export type TCheckProfitBoostPayload = {
  data: TAdvancedFreebet[];
  eventId: string | number | null;
  isAdvancedMultiple: boolean;
};
export type TToggleProfitBoostPayload = {
  eventId: number | string | null;
  isActive: boolean | null;
};

export const fireCheckProfitBoost = (
  data: TCheckProfitBoostPayload['data'],
  eventId: TCheckProfitBoostPayload['eventId'] = null,
  isAdvancedMultiple: TCheckProfitBoostPayload['isAdvancedMultiple'] = false
) => {
  fireEvent({
    key: EProfitBoostActions.CHECK_PROFIT_BOOST,
    payload: {
      eventId,
      data,
      isAdvancedMultiple
    }
  });
};

export const fireToggleProfitBoost = (
  eventId: TToggleProfitBoostPayload['eventId'] = null,
  isActive: TToggleProfitBoostPayload['isActive'] = null
) => {
  fireEvent({
    key: EProfitBoostActions.TOGGLE_PROFIT_BOOST,
    payload: { eventId, isActive }
  });
};
